// Create a array with week numbers from 1 to 52
export const weekArray = Array.from({ length: 52 }, (_, index) => index + 1);
